/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
window.addEventListener('load', (event) => {
  
  function ProductVariants(container, productId) {
    var _this5 = this;

    this.element = container;
    this.delegateElement = "";
    this.options = {useAjaxCart: true};

    var jsonData = JSON.parse(document.querySelector('[data-product-json-' + productId + ']').innerHTML);

    this.productData = jsonData['product'];
    this.variantsInventories = jsonData['inventories'] || {};
    this.masterSelector = document.querySelector('#product-select-' + this.productData['id']);

    // We init value with the first selected variant
    this.productData['variants'].forEach(function (variant) {
      if (variant['id'] === jsonData['selected_variant_id']) {
        _this5.currentVariant = variant;
        _this5.option1 = variant['option1'];
        _this5.option2 = variant['option2'];
        _this5.option3 = variant['option3'];
      }
    });

  }
  
  var addToCartButtons = document.querySelectorAll('[data-productid]');

  for(var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', function addToCart(event) {
      var _this8 = this;
      event.preventDefault();

      // First, we switch the status of the button
      _this8.setAttribute('disabled', 'disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      // Then we add the product in Ajax
      var productid = this.dataset.productid
      var formElement = document.querySelector('form#product_form_' + productid + '[action^="/cart/add"]');

      var body = {
        "form_type": "product",
        "utf8": "✓",
        "id": this.dataset.variantid,
        "quantity": "1"
      }
      
      fetch('/cart/add.js', {
        body: JSON.stringify(body),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
      }).then(function (response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        if (response.ok) {
          ProductVariants(formElement, productid)
          _this8.removeAttribute('disabled');
          // We simply trigger an event so the mini-cart can re-render
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
             variant: _this8.currentVariant,
             quantity: 1
            }
          }));
        } else {
          _this8.removeAttribute('disabled');
        }
      });

    });
  }
  
});